import React from 'react';
import DateRangeSelector from '../DateRangeSelector';
import SegmentedControl from './SegmentedControl';
import GPSFilterSelect from './GPSFilterSelect';
import { getFilterLayout } from './gpsFilters.config';
import { useGPS } from '../../contexts/GPSContext';

const SENSE_OPTIONS = [
  { value: 'all', label: 'Tout', dot: '#5b3df0' },
  { value: 'received', label: 'Reçus', dot: '#2f6df0' },
  { value: 'resolved', label: 'Fermés', dot: '#16a866' },
  { value: 'ongoing', label: 'Encours', dot: '#3a4a63' },
];

const fieldLabel = 'block text-xs font-semibold text-gray-700 dark:text-gray-300 text-left mb-1.5';

const GPSFiltersBaseRow = ({ jail = false, senseDisabled = false, senseValueOverride = null }) => {
  const gps = useGPS();
  const { promoted } = getFilterLayout(gps, jail);

  const onDatesChange = ({ startDate: s, endDate: e }) => {
    gps.setStartDate(s);
    gps.setEndDate(e);
    // periodType is resolved authoritatively by DateRangeSelector via
    // onPeriodTypeResolved (handles presets, custom ranges and URL deep-links alike).
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.3fr_1fr_1fr_1fr] gap-3">
      <div>
        <label className="flex items-center gap-1.5 text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
          Afficher
          <span
            title="Définit ce que la plage de dates signifie : flux (événements datés sur la période) ou encours (état à date)."
            className="inline-flex w-3.5 h-3.5 rounded-full border border-gray-300 dark:border-gray-600 text-gray-400 items-center justify-center text-[9px] font-bold cursor-help"
          >
            i
          </span>
        </label>
        <SegmentedControl
          size="s"
          className="min-h-[40px]"
          value={senseValueOverride ?? gps.sense}
          onChange={gps.setSense}
          options={SENSE_OPTIONS}
          disabled={senseDisabled}
          disabledTitle={senseValueOverride
            ? 'Cet onglet ne porte que sur les tickets fermés de la période.'
            : 'Le filtre « Afficher » est sans effet sur cet onglet.'}
        />
      </div>

      <div>
        <label className={fieldLabel}>Période</label>
        <DateRangeSelector
          startDate={gps.startDate}
          endDate={gps.endDate}
          onDatesChange={onDatesChange}
          onPeriodTypeResolved={gps.setPeriodType}
          maxDateRange={{ value: 12, unit: 'months' }}
          relative={false}
          includeFuture={false}
        />
      </div>

      {/* Promoted data filters fill the slot(s) freed by hidden fixed controls (jail). */}
      {promoted.map((def) => (
        <GPSFilterSelect key={def.key} def={def} gps={gps} />
      ))}
    </div>
  );
};

export default GPSFiltersBaseRow;
